export const ROLE_TYPE = {
  CLERKS: "CLERKS", // 收文员
  DEP_CLERKS: "DEP-CLERKS", // 部门收文员
  MEETING: "MEETING", // 会议会务
  HR_ADMIN: "HR_ADMIN", // 人事管理员
  HR_USER: "HR_USER", // 人事普通用户
  ADMIN: "ADMIN", // 单位管理员
  USER: "USER", // 通用用户
  LEADER: "LEADER", // 领导
  MANAGER: "MANAGER", // 部门领导
  "MEETING-MANAGER": "MEETING-MANAGER", // 会务收发员
  "ASSIGNED-LEADER": "ASSIGNED-LEADER", // 分管领导
}